import React, { useCallback, useMemo, useState } from "react";

import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";

import CarouselComponent from "../../CarouselComponent";
import ImgShape from "../ImgShape";

const CarouselContainer = styled.div``;

const Dot = styled.div`
    width: 15px;
    height: 15px;
    margin: 5px;
    background-color: ${({ active, theme }) =>
        active ? theme.colors.red.toString() : "transparent"};
    border: 2px solid ${({ theme }) => theme.colors.white.toString()};
    border-radius: 50%;
    outline: 1px solid ${({ theme }) => theme.colors.red.toString()};

    &:hover {
        cursor: pointer;
    }
`;

const renderDotsItem = ({ isActive }) => {
    return <Dot active={isActive} />;
};

const HeroSlider = ({ heroes }) => {
    const [initialized, setInitialized] = useState(false);
    const theme = useTheme();

    const onInitialized = () => {
        setInitialized(true);
    };

    const sliderElements = useMemo(
        () =>
            heroes.map((hero, index) => (
                <ImgShape {...hero} key={index} hasTextOutline={true} />
            )),
        [heroes]
    );

    const playBtnOffset = (heroes.length * 25) / 2 + 30;

    const carouselContainerStyles = css`
        display: ${initialized ? "block" : "none"};

        .alice-carousel__play-btn {
            top: unset;
            right: calc(50% - ${playBtnOffset}px);
            bottom: 7px;
            left: unset;
            margin-top: 0;
            transform: translateY(-100%);

            .alice-carousel__play-btn-wrapper {
                background-color: transparent;
            }
        }

        .alice-carousel__dots {
            margin-top: 0;
            transform: translateY(-100%);
        }
    `;

    const placeholderStyles = css`
        display: ${initialized ? "none" : "block"};
        margin-bottom: 33px;
    `;

    const renderPlayPause = useCallback(({ isPlaying }) => {
        return (
            <div>
                {isPlaying ? (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill={theme.colors.red.toString()}
                        stroke={theme.colors.white.toString()}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-pause"
                    >
                        <rect x="6" y="4" width="4" height="16"></rect>
                        <rect x="14" y="4" width="4" height="16"></rect>
                    </svg>
                ) : (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill={theme.colors.red.toString()}
                        stroke={theme.colors.white.toString()}
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-play"
                    >
                        <polygon points="5 3 19 12 5 21 5 3"></polygon>
                    </svg>
                )}
            </div>
        );
    }, []);

    return (
        <>
            <ImgShape {...heroes[0]} css={placeholderStyles} />
            <CarouselContainer css={carouselContainerStyles}>
                <CarouselComponent
                    autoPlay
                    autoPlayControls
                    autoPlayStrategy="none"
                    autoPlayInterval={5000}
                    animationType="fadeout"
                    animationDuration={800}
                    items={sliderElements}
                    infinite
                    disableButtonsControls
                    renderDotsItem={renderDotsItem}
                    renderPlayPauseButton={renderPlayPause}
                    controlsStrategy="alternate"
                    touchTracking={false}
                    onInitialized={onInitialized}
                />
            </CarouselContainer>
        </>
    );
};

export default HeroSlider;
